import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import NavElement from './NavElement';
import { HeaderNavList } from '../../constants/NavConsts'
import styles from './HeaderNav.style';

class HeaderNav extends PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {HeaderNavList.map((item) => {
          return <NavElement {...item} />
        })}
      </div>
    )
  }
}

export default withStyles(styles)(HeaderNav)